/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1MoneyMarketScheduleVersionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_VERSION_STATE_ENTITY_NAME = 'ixf.hours.v1.MoneyMarketScheduleVersion';
export const ixfHoursV1MoneyMarketScheduleVersionStateEntity = new schema.Entity<IxfHoursV1MoneyMarketScheduleVersionState>(IXF_HOURS_V1_MONEY_MARKET_SCHEDULE_VERSION_STATE_ENTITY_NAME, {}, { idAttribute: 'moneyMarketScheduleVersionId' });

